const updateSelectedItemsUsingUpdaters = (allowMulti, newItem, selectedList, onRemove, onAdd, onSelect) => {
  const doesSelectedHaveNewItem = selectedList.contains(newItem);
  if (allowMulti) {
    if (doesSelectedHaveNewItem) {
      onRemove(newItem);
    } else {
      onAdd(newItem);
    }
  } else if (!doesSelectedHaveNewItem || selectedList.size > 1) {
    // has and new item is not the only one
    onSelect(newItem);
  }
};

const updateSelectedRowsArray = (allowMulti, newItem, selectedArray) => {
  let resultArr = selectedArray;
  if (allowMulti) {
    if (selectedArray.indexOf(newItem) >= 0) {
      resultArr = resultArr.filter(rId => rId !== newItem);
    } else {
      resultArr.push(newItem);
    }
  } else {
    resultArr = [newItem];
  }
  return resultArr;
};

export { updateSelectedItemsUsingUpdaters, updateSelectedRowsArray };
